// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as UsersADefault } from '../../../assets/icons/default/users/users-a.svg?react';
import { ReactComponent as UsersASolid } from '../../../assets/icons/solid/users/USERS-A.svg?react';
import { createIcons } from '../../Icon';
const UsersAIcon = /* @__PURE__ */ createIcons('UsersA', {
    default: UsersADefault,
    solid: UsersASolid
});
UsersAIcon.supportedTypes = ['default', 'solid'];
UsersAIcon.category = 'users';
export default UsersAIcon;
